import { createTaskFolderService } from 'owa-todo-service';
import { TodoFolder, createTodoFolder as createTodoFolderFromPartial } from 'owa-todo-types';
import { addFolder } from '../mutators/todoFolderStoreMutators';

export function createTodoFolder(partialFolder: Partial<TodoFolder>): Promise<TodoFolder | null> {
    const todoFolder = createTodoFolderFromPartial(partialFolder);

    return createTaskFolderService(todoFolder).then(todoFolder => {
        if (todoFolder) {
            addFolder(todoFolder);
        }

        return todoFolder;
    });
}
